module.exports = __webpack_public_path__ + "img/EXTERIOR-CIAZ-4.bbef479d.jpg";